export const SET_AUDIOS = 'SET_AUDIOS';
export const SET_AUDIO = 'SET_AUDIO';
export const ADD_AUDIO = 'ADD_AUDIO';
export const UPDATE_AUDIO = 'UPDATE_AUDIO';
export const REMOVE_AUDIO = 'REMOVE_AUDIO';
export const CLEAR_AUDIO = 'CLEAR_AUDIO';
export const CLEAR_AUDIOS = 'CLEAR_AUDIOS';
